var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { attrs: { id: "section-info" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "12", md: "12", sm: "12", xs: "12" } },
                [
                  _c(
                    "div",
                    { staticClass: "section-info-panel" },
                    [
                      _c("p", [
                        _vm._v(
                          "\n            Zephyr Drone Simulator is a full-featured drone training software\n            for drone instructors, flight academies, professionals and\n            hobbyists. Our advanced UAV simulator trains drone pilots to\n            safely and efficiently operate according to FAA guidelines. Zephyr\n            uses real-world physics and a constantly expanding library of\n            training modules and drone platforms meticulously crafted with\n            accurate flight characteristics for cutting-edge drone pilot\n            training.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "alt-primary",
                            to: { name: "individuals" },
                          },
                        },
                        [_vm._v("\n            Starting at $9.99\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }